<ng-container>
	<mat-card *ngIf="hasData" class="panel" style="display: block;background: #212121;" ngClass.xs="shotdata-xs" ngClass.lt-md="shotdata-xs">
		<mat-card-content class="panel-content ballistic" fxFlex="100">
			<div style="max-width:100%;">
				<div [ngStyle]="style" fxLayout="row wrap" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="center" class="ballistic-list">
					<div fxFlex="100" fxLayout="row" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle( 4)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue(4) | fixed:2}}</div>
						</div>
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle( 2)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue(2) | fixed:2}}</div>
						</div>
					</div>
					<div fxFlex="100" fxLayout="row" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle( 6)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue(6) | fixed:2}}</div>
						</div>
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle(9)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue(9) | fixed:2}}</div>
						</div>
					</div>
					<div fxFlex="100" fxLayout="row" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle(5)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue(5) | fixed:2}}</div>
						</div>
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle(10)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue(10) | fixed:2}}</div>
						</div>
					</div>
					<div fxFlex="100" fxLayout="row" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle(0)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue( 0) | fixed:2}}</div>
						</div>
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle( 8)}}</span></div> <!-- 左右ブレ(yard) -->
							<div class="data-cell" fxFlex="35">{{itemValue( 8) | fixed:2}}</div>
						</div>
					</div>
					<div fxFlex="100" fxLayout="row" fxLayout.lt-sm="column" fxLayout.lt-md="column" fxLayoutAlign="space-around" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around">
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle(7)}}</span></div>
							<div class="data-cell" fxFlex="35">{{itemValue( 7) | fixed:2}}</div>
						</div>
						<div fxFlex="35" fxLayout="row" fxLayoutAlign.lt-sm="space-around" fxLayoutAlign.lt-md="space-around" class="ballistic-row">
							<div class="title-cell" fxFlex="65" fxFlex.lt-sm="50" fxFlex.lt-md="50"><span translate>{{itemTitle( 1)}}</span></div> <!-- 左右ブレ(yard) -->
							<div class="data-cell" fxFlex="35">{{itemValue( 1) | fixed:2}}</div>
						</div>
					</div>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</ng-container>
